import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param email
 * @return {Promise<any>|Promise}
 */
export default (function (email) {
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({
        method: Methods.POST,
        url: EndPoints.FORGOT_PASSWORD,
        withCredentials: false,
        headers: headers,
        data: JSON.stringify(email)
    });
    return request.execute();
});
